<div class="col-xl-8 m-auto text-center pt-4">
  <h2>Create Your OUK Account</h2>
  <p class="signin pt-2">
    Already have an Account? <a href="/login" style="color: #ff5722">Sign In</a>
  </p>
  <div class="ouk-form-wrapper">
    <form [formGroup]="signUpForm">
      <div class="ouk-form align-items-start">
        <label class="ouk-label" for="email"
          >Email Address<span class="ouk-required">*</span></label
        >
        <input
          class="ouk-input"
          type="email"
          autocomplete="off"
          placeholder="Email"
          (change)="validateEmail($event)"
          formControlName="UserName"
          maxlength="100"
          onpaste="return false"
          (keypress)="blockSpace($event)"
        />
        <div class="ouk-note">
          Your email address is your username. Click
          <a href="javascript:void()" style="color: #037b90">here</a> to get
          help.
        </div>

        <label class="ouk-label" for="password"
          >Password<span class="ouk-required">*</span></label
        >
        <!-- <input
          class="ouk-input"
          [type]="showPassword ? 'text' : 'password'"
          placeholder="Password"
          formControlName="password"
          autocomplete="new-password"
          (input)="checkPassword()"
          (paste)="disablePaste($event)"
          (copy)="disableCopy($event)"
          (cut)="disableCut($event)"
          style="padding-right: 2.5rem; width: 100%"
        />
        <span (click)="togglePassword()">
          <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span> -->
        <div>
          <div class="input-group">
            <input
              class="form-control ouk-input w-75"
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Password"
              formControlName="password"
              autocomplete="new-password"
              (change)="checkPassword()"
              (paste)="disablePaste($event)"
              (copy)="disableCopy($event)"
              (cut)="disableCut($event)"
              (keypress)="blockSpace($event)"
            />

            <button
              type="button"
              class="btn btn-outline-secondary border-start-0"
              (click)="togglePassword()"
              tabindex="-1"
            >
              <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>

          <div class="password-feedback">
            <div
              *ngFor="let msg of passwordFeedback"
              [ngClass]="{
                'text-danger': msg !== 'Password looks good!',
                'text-success': msg === 'Password looks good!'
              }"
            >
              {{ msg }}
            </div>
          </div>
        </div>

        <div class="ouk-note">
          Passwords must have upper and lower case letters, at least 1 number
          and special character, not match or contain email, and be at least 8
          characters long.
        </div>

        <label class="ouk-label" for="retype-password"
          >Retype Password<span class="ouk-required">*</span></label
        >
        <input
          class="ouk-input"
          type="password"
          autocomplete="off"
          placeholder="Retype Password"
          formControlName="confirmPassword"
          (input)="checkConfirmPassword()"
          onpaste="return false"
          (paste)="disablePaste($event)"
          (copy)="disableCopy($event)"
          (cut)="disableCut($event)"
          (keypress)="blockSpace($event)"
        />
        <div>
          <div
            *ngFor="let msg of confirmPasswordFeedback"
            [class.text-danger]="msg !== 'Passwords match!'"
            [class.text-success]="msg === 'Passwords match!'"
          >
            {{ msg }}
          </div>
        </div>

        <label class="ouk-label" for="programme"
          >Programme<span class="ouk-required">*</span></label
        >
        <!-- <select class="ouk-select" id="programme">
        <option>Select Programme</option>
      </select> -->
        <app-search-dropdown
          [SearchData]="programSearchData"
          (notify)="changeProgramDropdown($event)"
        ></app-search-dropdown>
        <div></div>

        <label class="ouk-label"
          >Gender<span class="ouk-required">*</span></label
        >
        <select class="ouk-select" autocomplete="off" formControlName="Gender">
          <option value="">Select Gender</option>
          <option [value]="item.DICTIONARYID" *ngFor="let item of gender">
            {{ item.DICTIONARYNAME }}
          </option>
        </select>
        <div></div>

        <label class="ouk-label" for="first-name"
          >First Name(s)<span class="ouk-required">*</span></label
        >
        <input
          class="ouk-input"
          type="text"
          autocomplete="off"
          placeholder="First Name(s)"
          maxlength="50"
          formControlName="FirstName"
          (input)="nameValidate($event)"
        />
        <div></div>

        <label class="ouk-label" for="middle-name">Middle Name</label>
        <input
          class="ouk-input"
          type="text"
          autocomplete="off"
          placeholder="Middle Name"
          maxlength="50"
          formControlName="middlename"
          (input)="nameValidate($event)"
        />
        <div></div>

        <label class="ouk-label" for="last-name"
          >Last Name<span class="ouk-required">*</span></label
        >
        <input
          class="ouk-input"
          type="text"
          autocomplete="off"
          placeholder="Last Name"
          maxlength="50"
          formControlName="LastName"
          (input)="nameValidate($event)"
        />
        <div></div>

        <label class="ouk-label"
          >ID Number/Birth certificate/Passport<span class="ouk-required"
            >*</span
          ></label
        >
        <!-- <input
          class="ouk-input"
          placeholder="Number"
          autocomplete="off"
          formControlName="id_passport"
        /> -->
        <input
          class="ouk-input"
          type="text"
          autocomplete="off"
          placeholder="Number"
          maxlength="50"
          formControlName="id_passport"
          (keypress)="noSpecialCharValidation($event)"
        />
        <div></div>

        <label class="ouk-label"
          >Date of birth (DD/MM/YYYY)<span class="ouk-required">*</span></label
        >
        <div class="ouk-dob-fields">
          <select
            class="ouk-select"
            [(ngModel)]="selectedDay"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off"
          >
            <option value="">Day</option>
            <option *ngFor="let day of days" [value]="day">
              {{ day }}
            </option>
          </select>
          <select
            class="ouk-select"
            [(ngModel)]="selectedMonth"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off"
          >
            <option value="">Month</option>
            <option *ngFor="let month of months" [value]="month">
              {{ month }}
            </option>
          </select>
          <select
            class="ouk-select"
            [(ngModel)]="selectedYear"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off"
            (change)="validateAge(); calculateAge()"
          >
            <option value="">Year</option>
            <option *ngFor="let year of years" [value]="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div></div>

        <label class="ouk-label" for="country"
          >Country of Residence<span class="ouk-required">*</span></label
        >
        <app-search-dropdown
          [SearchData]="countrySearchData"
          (notify)="changeSearchDropdown($event)"
        ></app-search-dropdown>
        <div></div>

        <label class="ouk-label"
          >Phone<span class="ouk-required">*</span></label
        >
        <div class="ouk-phone-fields">
          <app-search-dropdown
            class="mobiledropdown"
            [SearchData]="mobileCodeData"
            (notify)="changeMobileCodeSearchDropdown($event)"
          ></app-search-dropdown>
          <input
            class="ouk-input"
            type="text"
            placeholder="712345678"
            (blur)="mobileValidation($event)"
            (keypress)="onKeyPress($event)"
            (paste)="onPaste($event)"
            maxlength="12"
            id="floatingInput"
            formControlName="Mobileno"
          />
        </div>
        <div></div>

        <label class="ouk-label"
          >Do you have a disability or additional learning need?<span
            class="ouk-required"
            >*</span
          ></label
        >
        <div class="ouk-radio-group">
          <label
            ><input
              type="radio"
              name="disability"
              [value]="false"
              formControlName="IS_DISABILITY"
            />
            No</label
          >
          <label
            ><input
              type="radio"
              name="disability"
              [value]="true"
              formControlName="IS_DISABILITY"
            />
            Yes</label
          >
        </div>
        <div></div>

        <label class="ouk-label" for="place-of-birth"
          >Place of Birth<span class="ouk-required">*</span></label
        >
        <input
          class="ouk-input"
          type="text"
          placeholder="Place of birth"
          autocomplete="off"
          formControlName="PLACE_OF_BIRTH"
        />
        <div></div>

        <label class="ouk-label" for="referral-code"
          >Referral Code
          <span style="color: grey">(Optional)</span>
        </label>

        <input
          class="ouk-input"
          type="text"
          autocomplete="off"
          placeholder="Referral Code"
          formControlName="REFERRAL_CODE"
          (input)="nameValidate($event)"
        />
        <div></div>
        <label class="ouk-label" for="county" *ngIf="isKenyan"
          >County<span class="ouk-required">*</span></label
        >
        <select
          *ngIf="isKenyan"
          class="ouk-select"
          autocomplete="off"
          formControlName="COUNTIES_ID"
        >
          <option value="0">Select County</option>
          <option *ngFor="let item of County" [value]="item.COUNTIES_CODE">
            {{ item.COUNTIES_NAME }}
          </option>
        </select>

        <div></div>

        <div class="ouk-checkbox-group d-flex align-items-start mb-3">
          <label for="confirm" class="fw-bold mb-1" style="white-space: nowrap">
            Please Confirm<span class="text-danger">*</span>
          </label>
          <input
            type="checkbox"
            id="confirm"
            formControlName="PLEASE_CONFIRM"
            class="mt-1 me-2"
            required
          />
          <div style="width: 54%; text-align: start">
            <div class="small">
              I acknowledge that creating an account does not mean I am enrolled
              in any programme, nor does it create a contract with The Open
              University of Kenya for academic services. I understand that a
              formal registration acceptance is required before any such
              engagement begins.
            </div>
          </div>
        </div>

        <div class="ouk-contact-preferences text-start">
          <h4>Your Contact Preferences</h4>
          By clicking the <strong>Create Account</strong> button below, you
          acknowledge and agree that your use of the OUK website is subject to
          the <a href="#">OUK Terms of Use</a>. Further information regarding
          how OUK collects and uses your personal data — including details on
          access, retention, correction, deletion, security measures and other
          related matters — can be found in the
          <a href="#">OUK Privacy Policy</a>.
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 text-center pb-5">
          <button
            type="submit"
            class="ouk-submit-btn text-center"
            (click)="onSubmit()"
          >
            Create Account
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal fade" id="emailVerifyModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content p-3">
      <div class="modal-header border-0">
        <h4 class="modal-title w-100 text-center">Check Your Email</h4>
      </div>
      <div class="modal-body">
        <h6 class="fw-bold">Verify your email address</h6>
        <p>
          We have sent a verification email to
          <strong>{{ EMAIL_ADDRESS }}</strong
          >. Please click the button in that email to confirm your address and
          activate your account.
        </p>
        <p>
          If you do not see the email, kindly check your spam or junk folder.
          You may also
          <a href="javascript:void()" (click)="updateVerification()"
            >request a new verification email</a
          >
          (available for up to 3 days).
        </p>
        <p>
          ⚠️ If your email address is not verified within 3 days, you will need
          to create a new account. For further assistance, please visit
          <a href="https://ouk.ac.ke/call-center" target="_blank"
            >OUK Account Help</a
          >.
        </p>
      </div>
      <div class="modal-footer border-0">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
